import { API_ENDPOINT } from '@/constant/constant.ts'

/** 서버에 닿지 못했을 때 message 에 담는 클라이언트 코드. 화면 문구는 호출한 쪽에서 t() 로 만든다. */
export const LOGIN_SERVER_UNREACHABLE = 'SERVER_UNREACHABLE'

type IResLogin = {
    token?: string
    accessToken?: string
    turnstileRequired?: boolean
    loginFailCount?: number
}

export interface IReqLogin {
    id: string
    password: string
    turnstileToken?: string
    rememberMe?: boolean
}

/** 게이트웨이 레이트 리밋이 직접 낸 429 의 `message`. 앱이 내는 계정 잠금(ACCOUNT_LOCKED)과 다르다. */
export const RATE_LIMITED_MESSAGE = 'RATE_LIMITED'

const parseRetryAfterSeconds = (value: string | null | undefined): number | undefined => {
    const seconds = value == null ? NaN : Number(value)
    return Number.isFinite(seconds) && seconds > 0 ? Math.ceil(seconds) : undefined
}

export const apiLogin = async (params: IReqLogin) => {
    try {
        const endpoint = `${API_ENDPOINT}/auth/login`
        const response = await fetch(endpoint, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(params),
            credentials: 'include'
        })

        const res = await response.json()
        const responseData = (res.data || {}) as IResLogin
        const turnstileRequired =
            res.turnstileRequired === true ||
            responseData.turnstileRequired === true ||
            res.message === 'TURNSTILE_REQUIRED'
        const loginFailCount = res.loginFailCount ?? responseData.loginFailCount

        return {
            data: {
                ...responseData,
                token: responseData.token || responseData.accessToken,
                turnstileRequired,
                loginFailCount
            },
            code: res.code as number,
            message: res.message as string,
            turnstileRequired,
            loginFailCount,
            remainingAttempts: res.remainingAttempts as number | undefined,
            remainingLockSeconds: res.remainingLockSeconds as number | undefined,
            maxAttempts: res.maxAttempts as number | undefined,
            retryAfterSeconds: parseRetryAfterSeconds(response.headers?.get('Retry-After'))
        }
    } catch {
        return {
            data: undefined,
            code: 500,
            message: LOGIN_SERVER_UNREACHABLE,
            turnstileRequired: undefined,
            loginFailCount: undefined,
            remainingAttempts: undefined,
            remainingLockSeconds: undefined,
            maxAttempts: undefined,
            retryAfterSeconds: undefined
        }
    }
}
